import React, { createContext, useContext, useState, useEffect } from "react";
import i18n from "../i18n.jsx";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem("spar-theme") === "dark";
  });

  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("spar-lang") || "en";
  });

  useEffect(() => {
    document.body.classList.toggle("dark", isDark);
    localStorage.setItem("spar-theme", isDark ? "dark" : "light");
  }, [isDark]);

  useEffect(() => {
    const isAr = language === "ar";
    document.documentElement.setAttribute("lang", language);
    document.documentElement.setAttribute("dir", isAr ? "rtl" : "ltr");
    localStorage.setItem("spar-lang", language);
    i18n.changeLanguage(language);
  }, [language]);

  const toggleTheme = () => setIsDark((prev) => !prev);
  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));

  return (
    <ThemeContext.Provider
      value={{ isDark, toggleTheme, language, setLanguage, toggleLanguage }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
